'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const RoadmapSection = () => {
  const roadmapItems = [
    {
      phase: 'Fase 1',
      status: 'Completado',
      title: 'Lanzamiento Versión Gratuita',
      description: 'Plataforma base con 5 mentores de IA especializados, sistema de tokens y coaching personalizado.',
      icon: 'CheckCircleIcon',
      color: 'text-green-600',
      bgColor: 'bg-green-100',
    },
    {
      phase: 'Fase 2',
      status: 'Completado',
      title: 'Versión Premium',
      description: 'Plan LynMet activo con 100 tokens mensuales, pagos con Mercado Pago, recargas puntuales y gestión del plan dentro de la app.',
      icon: 'CheckCircleIcon',
      color: 'text-green-600',
      bgColor: 'bg-green-100',
    },
    {
      phase: 'Fase 3',
      status: 'En Desarrollo',
      title: 'Matchmaking con Inversionistas',
      description: 'Conexión directa entre emprendedores e inversionistas basada en IA, perfiles de inversión y presentaciones optimizadas.',
      icon: 'UsersIcon',
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-100',
    },
    {
      phase: 'Fase 4',
      status: 'Futuro',
      title: 'Ecosistema Completo',
      description: 'Comunidad de emprendedores, eventos virtuales, recursos educativos y red de mentores humanos complementarios.',
      icon: 'GlobeAltIcon',
      color: 'text-pink-600',
      bgColor: 'bg-pink-100',
    },
  ];

  return (
    <section className="relative overflow-hidden py-20 lg:py-32 bg-[radial-gradient(circle_at_top_left,rgba(44,120,251,0.08),transparent_26%),radial-gradient(circle_at_bottom_right,rgba(62,224,190,0.12),transparent_30%),linear-gradient(180deg,#ffffff_0%,#f5fbff_40%,#eefcf8_100%)]">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-0 top-20 h-64 w-64 rounded-full bg-[rgba(44,120,251,0.10)] blur-3xl" />
        <div className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-[rgba(62,224,190,0.12)] blur-3xl" />
      </div>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="section-eyebrow mb-6">
            <Icon name="MapIcon" size={18} className="text-[var(--primary)]" />
            <span>Hoja de Ruta</span>
          </div>

          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6">
            El{' '}
            <span className="bg-clip-text text-transparent" style={{ backgroundImage: 'var(--gradient-app)' }}>
              Futuro de LynMet
            </span>
          </h2>

          <p className="text-xl text-gray-600 leading-relaxed">
            Estamos comprometidos con la evolución continua de nuestra plataforma. Conoce lo que viene y cómo seguiremos apoyando tu crecimiento empresarial.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {roadmapItems?.map((item, index) => (
            <div
              key={index}
              className="app-card p-8 border border-[rgba(44,120,251,0.14)] hover:border-[rgba(44,120,251,0.30)] hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-start space-x-4">
                <div className={`${item?.bgColor} w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0`}>
                  <Icon name={item?.icon} size={28} className={item?.color} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-3">
                    <span className="text-sm font-bold text-gray-500 uppercase tracking-wide">{item?.phase}</span>
                    <span className={`text-xs font-semibold px-3 py-1 rounded-full ${item?.bgColor} ${item?.color} border border-transparent`}>
                      {item?.status}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{item?.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{item?.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Investor Matchmaking Highlight */}
        <div className="mt-16 rounded-3xl p-8 lg:p-12 text-center text-white relative overflow-hidden shadow-2xl" style={{ backgroundImage: 'linear-gradient(135deg, #0f3f87 0%, #2c78fb 48%, #3ee0be 100%)' }}>
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute top-10 left-10 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
            <div className="absolute bottom-10 right-10 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
          </div>
          <div className="relative z-10">
            <Icon name="LightBulbIcon" size={48} className="text-yellow-300 mx-auto mb-4" />
            <h3 className="text-3xl font-bold mb-4">Matchmaking con Inversionistas</h3>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Pronto podrás conectar directamente con inversionistas estratégicos que buscan proyectos como el tuyo. Nuestra IA analizará tu perfil empresarial y te conectará con las oportunidades de inversión más relevantes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadmapSection;
